import { WORK_CHAT_HOME_PATH } from '@heidi/agents/contracts';
import { stripLocalePathPrefix } from '@heidi/utils/i18n';
import { atom } from 'jotai';

/** True when `pathname` is Work Home itself (no project id), locale prefix aside. */
export function isHomeBootPath(pathname: string): boolean {
  return stripLocalePathPrefix(pathname).replace(/\/+$/, '') === WORK_CHAT_HOME_PATH;
}

/**
 * The path the document was loaded with, from the navigation timing entry, so
 * it stays the boot URL however late this module is evaluated and however far
 * the SPA has navigated since. `null` when the entry is unavailable.
 */
export function readBootPathname(): string | null {
  if (
    typeof window === 'undefined' ||
    typeof performance?.getEntriesByType !== 'function'
  ) {
    return null;
  }
  const entry = performance.getEntriesByType('navigation')[0];
  if (!entry?.name) return null;
  try {
    return new URL(entry.name).pathname;
  } catch {
    return null;
  }
}

/**
 * True once this boot landed on Work Home: the `/scribe` resolver handed off to
 * it, or the Home host found the document was loaded there (reload, bookmark,
 * restored tab). Starts false so server and first client render agree; memory
 * only, so a reload or relaunch starts over and a sidebar visit never sets it.
 */
export const hasBootLandedOnHomeAtom = atom(false);

/**
 * True once the `/scribe` resolver has handed off anywhere in this document.
 * Only that first hand-off is the boot landing; the resolver remounts on
 * in-app redirects to `/scribe` (inbox, translator, clear-cache) and those
 * must not re-mark the boot.
 */
export const hasBootHandOffHappenedAtom = atom(false);
